function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { splitter } from "../components/Listing";
export const getLangPrefixLink = (link, langPrefix) => {
  const trimmedLink = link.trim();
  if (!trimmedLink || trimmedLink === '/') {
    return `/${langPrefix}/`;
  }
  if (trimmedLink.startsWith('http')) {
    return trimmedLink;
  }
  const noSlashTrimmedLink = trimmedLink.startsWith('/') ? trimmedLink.substring(1) : trimmedLink;
  const splitted = noSlashTrimmedLink.split('/');
  if (splitted[0] === langPrefix) {
    return `/${noSlashTrimmedLink}`;
  }
  return `/${langPrefix}/${noSlashTrimmedLink}`;
};
export const getGlobalDictionaryTerm = (sitecoreContext, termKey) => {
  if (!termKey || !sitecoreContext) {
    return;
  }
  const dictionary = sitecoreContext.globalDictionary && sitecoreContext.globalDictionary.items;
  if (!dictionary) {
    return;
  }
  const term = dictionary.find(termObj => termObj.key === termKey);
  return term && term.value;
};
export const getMediaHost = () => process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '/';
export const getDomain = () => {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return '/';
};
export function pathJoin(parts) {
  let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  const replace = new RegExp(separator + '{1,}', 'g');
  return parts.join(separator).replace(replace, separator);
}
export function get(obj, propPath, defaultValue) {
  return getPropertyByPath(obj, propPath, defaultValue);
}
export function getPropertyByPath(obj, propPath, defaultValue) {
  return propPath.split('.').reduce((o, p) => o && o[p] || defaultValue, obj);
}
export const reduceHits = function () {
  let hits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let isShowFeatured = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const [first] = hits;
  return first && first.featured && isShowFeatured ? hits : hits.slice(0, -1);
};

// homebrew date formatting supporting English and Arabic to reduce size of JS bundle
export const getFormatedDate = function (date, language) {
  let includeDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!language) {
    return getFormatedDateForEn(date);
  }
  const languageCode = language.toLocaleLowerCase();
  if (languageCode === 'en') {
    return getFormatedDateForEn(date, includeDay);
  } else if (languageCode === 'ar') {
    return getFormatedDateForAr(date, includeDay);
  }
  return getFormatedDateForEn(date);
};
const parseDate = date => {
  const isoDateRegEx = new RegExp('^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$');
  let d = new Date();
  if (!isNaN(Number(date.toString()))) {
    d = new Date(date);
  } else if (isoDateRegEx.test(date.toString())) {
    d = new Date(date.toString());
  } else {
    d = new Date(date + 'T00:00:00.000');
  }
  return d;
};
const getFormatedDateForEn = function (date) {
  let includeDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const d = parseDate(date);
  if (includeDay) {
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
  } else {
    return `${months[d.getMonth()]} ${d.getFullYear()}`;
  }
};
export const twoDigitsFormat = num => {
  const str = num.toString();
  return str.length === 1 ? "0" + str : str;
};
export const monthList = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

// dd-month-yyyy Format
export const getFormatedDateForAnalytics = date => {
  return `${twoDigitsFormat(date.getDate())}-${monthList[date.getMonth()]}-${date.getFullYear()}`;
};
const getFormatedDateForAr = function (date) {
  let includeDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const months = ['يناير', 'فبراير', 'مارس', 'إبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  const days = ['اﻷحد', 'اﻷثنين', 'الثلاثاء', 'اﻷربعاء', 'الخميس', 'الجمعة', 'السبت'];
  const d = parseDate(date);
  if (includeDay) {
    return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]}, ${d.getFullYear()}`;
  } else {
    return `${months[d.getMonth()]}, ${d.getFullYear()}`;
  }
};
export const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
export const getRecentSearches = () => {
  if (!canUseDOM) {
    return [];
  }
  const localStorageValue = localStorage.getItem('recentSearches');
  if (localStorageValue != null) {
    return JSON.parse(localStorageValue);
  }
  return [];
};
export const saveRecentSearches = recentSearches => {
  if (!recentSearches || !canUseDOM) {
    return;
  }
  localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
};
export const isClient = () => typeof window !== undefined;
export const isChina = () => {
  if (canUseDOM) {
    const urlParams = new URLSearchParams(document.location.search);
    const isC = Boolean(urlParams.get('isChina') === 'true');
    return isC;
  } else {
    return false;
  }
};
export const getListingItemURL = (host, url, fullURL, isChina) => {
  const generatedHost = host.split('?')[0];
  return generatedHost ? `${generatedHost}\/${url}` : fullURL;
};
const getLocation = href => {
  var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7]
  };
};
export const getVideoItemURL = function () {
  let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let isChina = arguments.length > 1 ? arguments[1] : undefined;
  const generatedHost = getLocation(url);
  // @ts-ignore
  return generatedHost && generatedHost.pathname ? generatedHost.pathname : url;
};
export const getListingLocation = () => {
  if (canUseDOM) {
    const {
      origin,
      pathname
    } = window.location;
    return pathname.slice(-1) == '/' ? `${origin}${pathname.slice(0, -1)}` : `${origin}${pathname}`;
  }
  return '';
};
export const pick = (obj, keys) => {
  return keys.map(k => k in obj ? {
    [k]: obj[k]
  } : {}).reduce((res, o) => Object.assign(res, o), {});
};
export const removeImageResolution = src => {
  if (!src) return '';
  const queryStr = src.split('?')[1];
  const clearedQueryStr = queryStr ? queryStr.split('&').filter(item => item.indexOf('h=') != 0 && item.indexOf('w=') != 0).join('&') : '';
  return src.split('?')[0] + '?' + clearedQueryStr;
};
export const injectImageResolution = (src, width, height) => {
  const imageSrc = removeImageResolution(src);
  return `${imageSrc}${imageSrc.match(/\?/) ? '&' : '?'}cw=${width}&ch=${height}`;
};
export const getDictionaryItem = (dictionary, value) => {
  if (dictionary) {
    const dictionaryItems = dictionary.dictionaryValues;
    let output = '';
    dictionaryItems.find(item => {
      if (item.key.jss.value.toLowerCase() === value.toLowerCase()) {
        if ('phrase' in item) {
          output = item.phrase.jss.value;
        }
        if ('image' in item) {
          output = item.image.jss.value;
        }
      }
    });
    return output;
  } else {
    return '';
  }
};
export const getDictionarySvg = (dictionary, value) => {
  if (dictionary) {
    const dictionaryItems = dictionary.dictionaryValues;
    let output = '';
    dictionaryItems.find(item => {
      if (item.key.jss.value.toLowerCase() === value.toLowerCase()) {
        if ('svg' in item) {
          output = item.svg.jss.value;
        }
      }
    });
    return output;
  } else {
    return '';
  }
};
export const generatrURLFromTags = function (tags) {
  let label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tags';
  let urlTags = `?${label}=`;
  let tagsNamesArray = getTagsNames(tags);
  return tagsNamesArray.length ? urlTags + encodeURIComponent(tagsNamesArray.join(splitter)) : '';
};
export const getTagsNames = (tags, prefix) => {
  let tagsArray,
    result = [];
  if (tags.length) {
    tagsArray = tags.map(item => {
      const tag = get(item, 'title.jss.value') || get(item, 'name') || '';
      return prefix ? prefix + tag : tag;
    });
    result = tagsArray.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });
  }
  return result;
};
export const getTags = (tags, propValue) => {
  const tagsValues = get(tags, 'values');
  if (tagsValues) {
    let tagsArray = [];
    tagsArray = tagsValues.map(item => {
      const tag = get(item, 'title.jss.value') || get(item, 'name');
      return propValue ? propValue + tag : 'tags:' + tag;
    });
    return tagsArray;
  } else {
    return [];
  }
};
export const getURLSearchByName = function (name) {
  let url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
export const hexToRgb = function (hex) {
  let valuesOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let color = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b).substring(1).match(/.{2}/g).map(x => parseInt(x, 16));
  return valuesOnly ? color.join(',') : `rgb(${color.join(',')})`;
};
export const getFeaturedItemAndList = function () {
  let list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const featuredList = list.filter(item => item.featured || item.item && item.item.featured);
  if (featuredList.length > 1) {
    featuredList.sort((a, b) => {
      return a.priority - b.priority;
    });
  }
  const featuredIndex = featuredList.length ? list.findIndex(item => item.objectID === featuredList[0].objectID) : -1;
  return {
    list: featuredIndex !== -1 ? [...list.slice(0, featuredIndex), ...list.slice(featuredIndex + 1)] : list,
    featured: list[featuredIndex]
  };
};
export const mobileCheck = () => {
  let check = false;
  (function (a) {
    if (typeof window !== 'undefined' && /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
export const hideContainerByChild = function () {
  let childClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let parentClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const child = document.querySelector(childClass);
  // @ts-ignore
  const parent = child.closest(parentClass);
  // @ts-ignore
  parent.style.display = 'none';
};
export const replaceWhitespace = function () {
  let val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return val && val.replace(/\s/g, '-');
};
export const getIdFromName = function () {
  let val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return val && val.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
};
const blackColoredThemes = ['#97999B', '#C8C9C7', '#00D3B4', '#FCAA28', '#D6D2C4', '#FFFFFF'];
export const getColorClassByTheme = themeColor => {
  if (blackColoredThemes.includes(themeColor)) {
    return 'black-colored-theme';
  } else {
    return 'white-colored-theme';
  }
};
export const getColorByTheme = themeColor => {
  if (blackColoredThemes.includes(themeColor)) {
    return '#000';
  } else {
    return '#fff';
  }
};
export const getPageThemeColors = function () {
  let isVDsite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  if (isVDsite) {
    return {
      primary: '#035E88',
      primary_active: '#004565'
    };
  }
  return {
    primary: '#005F66',
    primary_active: '#115E67'
  };
};
export const replaceUrlPluses = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let isSwitch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (str) {
    let arr = str.split('');
    let plusIndexes = [];
    arr.forEach((item, index) => {
      if (item === '+') {
        plusIndexes.push(index);
      }
    });
    if (isSwitch) {
      if (str.includes('+') && str.includes('%20')) {
        return str.replace(/\%20/g, ' ');
      } else {
        let newStr = str;
        let newStrArr = str.split('');
        plusIndexes.forEach((el, i) => {
          // 5++days -> 5+ days
          if (el + 1 === plusIndexes[i + 1]) {
            newStrArr[el + 1] = ' ';
            newStr = newStrArr.join('');
          } else if (plusIndexes.length === 1 && newStrArr[el + 1] === ' ') {
            return str;
          }
          // 5%2B+days
          else if (plusIndexes.length === 1 && str.includes('%2B') && str.includes('+')) {
            newStr = str;
            newStr = newStr.replace(/\+/g, ' ');
            newStr = newStr.replace(/\%2B/g, '+');
          }
          //business+events;,leisure+events;art+&+events
          else {
            newStrArr[el] = ' ';
            newStr = newStrArr.join('');
          }
        });
        return newStr;
      }
    } else {
      return str.replace(/\+/g, ' ');
    }
  }
};
export const NAV_LINKS = {
  search: 'Search',
  eventCalendar: 'Event calendar',
  topPicks: 'Top picks',
  venuesShortlist: 'Venues Shortlist',
  interactiveMap: 'Interactive map'
};
export const isNavLinkRendered = (menulinks, key) => {
  const activeItem = menulinks.filter(link => (link.name && link.name.toLowerCase()) === (key && key.toLowerCase()));
  if (activeItem.length > 0) {
    return activeItem[0];
  } else {
    return null;
  }
};
export const celsiusToFahrenheit = tC => {
  return +(tC * 1.8 + 32).toFixed(1);
};
export const getLimitedText = function (field) {
  let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (typeof field === 'string') {
    return field.length <= limit ? field : field.substring(0, limit).concat(end);
  }
  return field.value.length <= limit ? field : _objectSpread(_objectSpread({}, field), {}, {
    value: field.value.substring(0, limit).concat(end)
  });
};
export const fileToBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = error => reject(error);
  });
};
export const getSizeFromBase64 = base64str => {
  const paddingCount = base64str.endsWith("==") ? 2 : base64str.endsWith("=") ? 1 : 0;
  return Math.floor(base64str.length * 3 / 4) - paddingCount;
};